export default __webpack_public_path__ + "static/media/Bell.af05c26f.svg";